var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragDropImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.33,
    height: 25.5,
    viewBox: "0 0 22.33 25.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_274",
    "data-name": "Grupo 274",
    transform: "translate(-7829.25 -2229.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_51",
    "data-name": "L\\xEDnea 51",
    y1: 5.434,
    transform: "translate(7840.868 2230)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_57",
    "data-name": "L\\xEDnea 57",
    y1: 5.434,
    transform: "translate(7840.868 2248.113)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_271",
    "data-name": "Trazado 271",
    d: "M.75,3.465,3.467.748,6.184,3.465",
    transform: "translate(7837.401 2229.252)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_272",
    "data-name": "Trazado 272",
    d: "M.75,20.248l2.717,2.717,2.717-2.717",
    transform: "translate(7837.401 2231.035)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_52",
    "data-name": "L\\xEDnea 52",
    x1: 20.83,
    transform: "translate(7830 2238.151)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_55",
    "data-name": "L\\xEDnea 55",
    x1: 20.83,
    transform: "translate(7830 2241.773)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_56",
    "data-name": "L\\xEDnea 56",
    x1: 20.83,
    transform: "translate(7830 2245.396)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDropImg);
export default __webpack_public_path__ + "static/media/DragDropImg.210419ca1cc19faafb8ca9e37d85c89a.svg";
export { ForwardRef as ReactComponent };